import styled from "styled-components"

export const Container = styled.div`
    background: #ff9b7c;
    box-shadow: 1px 2px 6px 0px rgba(37, 62, 145, 0.17);
    transition: all 0.5s ease;
    padding: 10px;
    border-radius: 5px;
    margin-top: 8px;
    margin-bottom: 8px;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const InfoText = styled.div`
    text-align: center;
    margin-bottom: 0;
    color: #fff;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
`